(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norua-octopus-review"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('norua-rack-gallery')) {
  customElements.define('norua-rack-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.no-gallery-track');
      this.slides = [...this.querySelectorAll('.no-gallery-slide')];
      this.thumbs = [...this.querySelectorAll('[data-gallery-index]')];
      this.counter = this.querySelector('[data-gallery-count]');
      this.index = 0;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.go(this.index + 1), options);
      this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.go(index), options));
      this.track.addEventListener('keydown', event => {
        const map = {ArrowRight: this.index + 1, ArrowLeft: this.index - 1, Home: 0, End: this.slides.length - 1};
        if (event.key in map) {event.preventDefault(); this.go(map[event.key]);}
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, {...options, passive: true});
      this.resizeObserver = new ResizeObserver(() => {
        this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: 'instant'});
      });
      this.resizeObserver.observe(this.track);
      this.update();
    }
    go(index) {
      const count = this.slides.length;
      if (!count) return;
      const next = (index + count) % count;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({left: next * this.track.clientWidth, behavior: reduced ? 'instant' : 'smooth'});
    }
    update() {
      this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
      this.thumbs.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.index)));
      if (this.counter) this.counter.textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
